(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tibatoes-affirmation"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllerKey = '__ttAffirmationsControllerV13';
  if (window[controllerKey]) {
    window[controllerKey].scan(document);
    return;
  }
  const instances = new Map();
  const selector = '[data-tt-affirmations]';
  const validId = value => Number.isSafeInteger(value) && value > 0;
  const localUrl = (value, suffix) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && url.pathname.endsWith(suffix) ? url.href : null;
    } catch {
      return null;
    }
  };

  const initialize = root => {
    if (instances.has(root)) return;
    const form = root.querySelector('[data-purchase-form]');
    const configNode = root.querySelector('script[data-config]');
    if (!form || !configNode) return;
    let config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch {
      return;
    }
    if (!config || typeof config !== 'object') return;
    if (Array.isArray(config.allOffers)) {
      config.offers = config.allOffers.slice(0, 3);
      config.regular = config.allOffers[3];
    }
    const all = query => Array.from(root.querySelectorAll(query));
    const one = query => root.querySelector(query);
    const texts = config.texts || {};
    const deadline = Date.parse(config.deadline);
    const validDeadline = Number.isFinite(deadline);
    const dispatchDate = Date.parse(config.dispatchDate);
    const validDispatch = Number.isFinite(dispatchDate);
    const deckNames = Array.isArray(config.deckNames) ? config.deckNames.filter(value => typeof value === 'string' && value.trim()) : [];
    const validDecks = deckNames.length === 3 && new Set(deckNames).size === 3;
    const offers = Array.isArray(config.offers) ? config.offers : [];
    const usesDeckVariants = config.purchaseMode === 'deck_variants';
    const deckVariants = Array.isArray(config.deckVariants) ? config.deckVariants : [];
    const currency = typeof config.currency === 'string' ? config.currency.trim().toUpperCase() : '';
    const shopCurrency = typeof config.shopCurrency === 'string' ? config.shopCurrency.trim().toUpperCase() : '';
    const moneyFormatters = new Map();
    const formatterFor = code => {
      if (moneyFormatters.has(code)) return moneyFormatters.get(code);
      let formatter = null;
      try {
        formatter = new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', { style: 'currency', currency: code });
      } catch {
        try {
          formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: code });
        } catch {}
      }
      moneyFormatters.set(code, formatter);
      return formatter;
    };
    const addUrl = localUrl(config.cartAddUrl, '/cart/add.js');
    const cartUrl = localUrl(config.cartUrl, '/cart');
    const eventController = new AbortController();
    const tierInputs = all('[data-tier]');
    const deckSelects = all('[data-deck-select]');
    const submitButtons = all('[data-submit]');
    const statuses = all('[data-form-status]');
    const sticky = one('[data-sticky]');
    const recoveries = all('[data-recovery-cart]');
    const drawerRetries = all('[data-open-cart]');
    let activePurchaseArea = form.closest('[data-purchase-area]') || form;
    let phase = validDeadline && Date.now() < deadline ? 'preorder' : 'regular';
    let beforeDispatch = validDispatch && Date.now() < dispatchDate;
    let selectedCount = phase === 'preorder' && (usesDeckVariants || offers.some(offer => offer.sets === 3 && validId(offer.id) && offer.available === true)) ? 3 : 1;
    let submitting = false;
    let confirmedAdd = false;
    let drawerPending = false;
    let drawerOpening = false;
    let uncertain = false;
    let destroyed = false;
    let timeout;
    let observer;
    let requestController;

    const setText = (query, value) => {
      if (typeof value !== 'string' && typeof value !== 'number') return;
      all(query).forEach(element => { element.textContent = String(value); });
    };
    const announce = message => {
      statuses.forEach(status => { status.textContent = typeof message === 'string' ? message : ''; });
    };
    const synchronizeSlot = source => {
      const slot = Number(source.dataset.slot);
      if (![1, 2, 3].includes(slot)) return;
      deckSelects.forEach(select => {
        if (select !== source && Number(select.dataset.slot) === slot) select.value = source.value;
      });
    };
    const localDeckSelect = slot => deckSelects.find(select => Number(select.dataset.slot) === slot && activePurchaseArea.contains(select));
    const selectionsFor = count => Array.from({ length: count }, (_, index) => {
      const select = deckSelects.find(element => Number(element.dataset.slot) === index + 1);
      return select && deckVariants.find(variant => variant.name === select.value);
    });
    const validPrice = price => Number.isSafeInteger(price) && price >= 0;
    const validAmount = price => typeof price === 'number' && Number.isFinite(price) && price >= 0 && price <= Number.MAX_SAFE_INTEGER;
    const validCurrency = code => /^[A-Z]{3}$/.test(code);
    const priceUnavailable = typeof texts.priceUnavailable === 'string' ? texts.priceUnavailable : 'Price unavailable';
    const formatPrice = (price, code = currency) => {
      if (!validAmount(price) || !validCurrency(code)) return null;
      const formatter = formatterFor(code);
      return formatter ? formatter.format(price / 100) : `${code === 'USD' ? 'US$' : `${code} `}${(price / 100).toFixed(currencyDecimals(code))}`;
    };
    const currencyDecimals = (code = currency) => {
      const formatter = formatterFor(code);
      if (formatter) return formatter.resolvedOptions().maximumFractionDigits;
      if (/^(BIF|CLP|DJF|GNF|ISK|JPY|KMF|KRW|PYG|RWF|UGX|UYI|VND|VUV|XAF|XOF|XPF)$/.test(code)) return 0;
      if (/^(BHD|IQD|JOD|KWD|LYD|OMR|TND)$/.test(code)) return 3;
      return code === 'CLF' || code === 'UYW' ? 4 : 2;
    };
    const decimals = currencyDecimals();
    const subunitScale = 10 ** decimals;
    const productId = value => {
      const match = String(value == null ? '' : value).match(/^(?:gid:\/\/shopify\/Product\/)?([1-9]\d*)$/);
      return match ? match[1] : null;
    };
    const configuredProductId = productId(config.productId);
    const configuredDealId = typeof config.kachingDealId === 'string' ? config.kachingDealId.trim() : '';
    const readPricing = () => {
      const tiers = {};
      [2, 3].forEach(count => {
        const value = config.tierDiscounts && config.tierDiscounts[count];
        tiers[count] = { type: 'amount', value: typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : 0 };
      });
      let roundCents = config.priceRounding === true && Number.isInteger(config.roundingCents) && config.roundingCents >= 0 && config.roundingCents <= 99 ? config.roundingCents : null;
      const matches = [];
      document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(node => {
        try {
          const data = JSON.parse(node.textContent);
          if (!data || !Array.isArray(data.dealBars)) return;
          const exactDeal = configuredDealId && String(data.id == null ? '' : data.id) === configuredDealId;
          const includedIds = data.blockVisibility === 'selected-products' && Array.isArray(data.selectedProductIds) ? data.selectedProductIds : [];
          const matchingProduct = configuredProductId && productId(node.dataset.productId) === configuredProductId && includedIds.some(id => productId(id) === configuredProductId);
          if (exactDeal || matchingProduct) matches.push({ data, priority: exactDeal ? 2 : 1 });
        } catch {}
      });
      matches.sort((a, b) => b.priority - a.priority);
      for (const { data } of matches) {
        let matchedTier = false;
        data.dealBars.forEach(bar => {
          if (!bar || ![2, 3].includes(Number(bar.quantity))) return;
          const count = Number(bar.quantity);
          const value = typeof bar.discountValue === 'number' || typeof bar.discountValue === 'string' && bar.discountValue.trim() ? Number(bar.discountValue) : NaN;
          if (!Number.isFinite(value) || value < 0 || !['amount', 'percentage'].includes(bar.discountType) || bar.discountType === 'percentage' && value > 100) return;
          tiers[count] = { type: bar.discountType, value };
          matchedTier = true;
        });
        if (!matchedTier) continue;
        if (data.priceRounding === false) roundCents = null;
        else if (data.priceRounding === true) {
          const match = String(data.priceRoundingPrecision || '').match(/\.(\d{2})/);
          if (match) roundCents = Number(match[1]);
        }
        break;
      }
      let rate = null;
      if (validCurrency(shopCurrency) && currency === shopCurrency) rate = 1;
      else {
        const shopifyCurrency = window.Shopify && window.Shopify.currency;
        const currentCurrency = shopifyCurrency && typeof shopifyCurrency.active === 'string' ? shopifyCurrency.active.toUpperCase() : '';
        const candidate = shopifyCurrency && (typeof shopifyCurrency.rate === 'number' || typeof shopifyCurrency.rate === 'string' && shopifyCurrency.rate.trim()) ? Number(shopifyCurrency.rate) : NaN;
        if (validCurrency(shopCurrency) && currentCurrency === currency && Number.isFinite(candidate) && candidate > 0) rate = candidate;
      }
      return { tiers, roundCents, rate };
    };
    let pricing = readPricing();
    let pricingSignature = JSON.stringify(pricing);
    const discountedPrice = (subtotal, count) => {
      const tier = phase === 'preorder' && pricing.tiers[count];
      if (!tier || tier.value <= 0) return subtotal;
      let off;
      if (tier.type === 'percentage') off = Math.round(subtotal * subunitScale / 100 * tier.value / 100) * 100 / subunitScale;
      else {
        if (pricing.rate == null) return subtotal;
        off = Math.round(tier.value * pricing.rate * subunitScale) * 100 / subunitScale * count;
      }
      if (!validAmount(off)) return subtotal;
      let total = Math.max(0, Math.round((subtotal - off) * subunitScale / 100) * 100 / subunitScale);
      if (total > 0 && off > 0 && decimals === 2 && pricing.roundCents != null) total = Math.floor((total + 1e-8) / 100) * 100 + pricing.roundCents;
      return Math.min(subtotal, Math.max(0, Math.round(total * subunitScale / 100) * 100 / subunitScale));
    };
    const offerFor = count => {
      const base = phase === 'preorder' ? offers.find(offer => offer.sets === count) : count === 1 ? config.regular : null;
      if (!usesDeckVariants || !base) return base;
      const chosen = selectionsFor(count);
      const merchandise = chosen[0];
      const hasPrice = chosen.length === count && chosen.every(variant => variant && validPrice(variant.price)) && validCurrency(currency);
      const subtotal = hasPrice ? chosen.reduce((sum, variant) => sum + variant.price, 0) : null;
      const price = hasPrice && validAmount(subtotal) ? discountedPrice(subtotal, count) : null;
      const available = validAmount(price) && chosen.every(variant => validId(variant.id) && variant.available === true && (!variant.sellingPlanId || validId(variant.sellingPlanId)));
      const unitPrice = hasPrice ? formatPrice(Math.round(price / count)) : null;
      const unitText = unitPrice && typeof texts.perSet === 'string' ? texts.perSet.replace(/\[price\]|\{\{\s*price\s*\}\}|\{price\}/g, unitPrice) : unitPrice ? `${unitPrice} / set` : '';
      return {
        ...base,
        sets: count,
        id: merchandise && merchandise.id,
        available,
        price,
        priceText: validAmount(price) ? formatPrice(price) || priceUnavailable : priceUnavailable,
        unitText,
        regularPrice: count === 1 ? merchandise && merchandise.regularPrice : hasPrice ? chosen.reduce((sum, variant) => sum + (validPrice(variant.regularPrice) && variant.regularPrice > variant.price ? variant.regularPrice : variant.price), 0) : null,
        sellingPlanId: merchandise && merchandise.sellingPlanId
      };
    };
    const currentOffer = () => offerFor(selectedCount);
    const usableOffer = offer => Boolean(offer && validId(offer.id) && offer.sets === selectedCount && offer.available === true && validAmount(offer.price) && typeof offer.priceText === 'string' && (!offer.sellingPlanId || validId(offer.sellingPlanId)));
    const ready = () => config.enabled === true && validDeadline && validDispatch && validDecks && Boolean(addUrl && cartUrl) && usableOffer(currentOffer()) && validCurrency(currency);
    const browsableOffer = offer => Boolean(offer && (usesDeckVariants || (validId(offer.id) && offer.available === true)));
    const updatePhase = () => {
      if (phase === 'preorder' && Date.now() >= deadline) {
        phase = 'regular';
        selectedCount = 1;
        return true;
      }
      return false;
    };
    const showCountdown = () => {
      if (!validDeadline) {
        setText('[data-countdown]', texts.unavailable);
        return;
      }
      if (phase !== 'preorder') {
        setText('[data-countdown]', texts.expired);
        return;
      }
      const minutes = Math.max(0, Math.ceil((deadline - Date.now()) / 60000));
      const days = Math.floor(minutes / 1440);
      const hours = Math.floor((minutes % 1440) / 60);
      const remainder = minutes % 60;
      setText('[data-countdown]', `${texts.countdown || ''} ${days}${texts.day || 'd'} ${hours}${texts.hour || 'h'} ${remainder}${texts.minute || 'm'}`.trim());
    };
    const renderComparison = (container, offer) => {
      const comparison = container.matches('[data-offer-comparison]') ? container : container.querySelector('[data-offer-comparison]');
      if (!comparison) return;
      const hasComparison = offer && validAmount(offer.price) && validPrice(offer.regularPrice) && offer.regularPrice > offer.price;
      const oldText = hasComparison ? formatPrice(offer.regularPrice) : null;
      const savingText = hasComparison ? formatPrice(offer.regularPrice - offer.price) : null;
      const visible = Boolean(oldText && savingText);
      comparison.hidden = !visible;
      const oldPrice = comparison.querySelector('[data-offer-old-price]');
      const savingAmount = comparison.querySelector('[data-offer-saving-amount]');
      if (oldPrice) oldPrice.textContent = visible ? oldText : '';
      if (savingAmount) savingAmount.textContent = visible ? savingText : '';
    };
    const render = () => {
      if (destroyed) return;
      const offer = currentOffer();
      const isPreorder = phase === 'preorder';
      const canPurchase = ready() && !submitting && !uncertain && !drawerOpening;
      root.dataset.offerPhase = phase;
      root.dataset.purchaseReady = ready() ? 'true' : 'false';
      all('[data-preorder-only]').forEach(element => { element.hidden = !isPreorder; });
      all('[data-regular-only]').forEach(element => { element.hidden = isPreorder; });
      all('[data-dispatch-only]').forEach(element => { element.hidden = !beforeDispatch; });
      all('[data-after-dispatch]').forEach(element => { element.hidden = beforeDispatch; });
      const selectedFirst = usesDeckVariants ? selectionsFor(1)[0] : null;
      const comparisonPrice = selectedFirst && selectedFirst.regularPrice;
      const showComparison = isPreorder && selectedFirst && validPrice(selectedFirst.price) && validPrice(comparisonPrice) && comparisonPrice > selectedFirst.price;
      setText('[data-regular-price]', usesDeckVariants ? showComparison ? formatPrice(comparisonPrice) || '' : '' : config.regular && config.regular.priceText);
      all('[data-regular-comparison]').forEach(element => { element.hidden = !showComparison; });
      setText('[data-price-currency]', currency);
      all('[data-currency-note]').forEach(element => { element.hidden = true; element.textContent = ''; });
      all('[data-summary-price]').forEach(element => {
        const count = Number(element.dataset.count || element.dataset.summaryPrice);
        const summaryOffer = offerFor(count);
        if (summaryOffer && typeof summaryOffer.priceText === 'string') element.textContent = summaryOffer.priceText;
      });
      all('[data-pick-tier]').forEach(button => {
        const count = Number(button.dataset.count || button.value || button.dataset.pickTier);
        const tier = offerFor(count);
        button.disabled = submitting || uncertain || !browsableOffer(tier);
        button.dataset.selected = count === selectedCount ? 'true' : 'false';
        button.setAttribute('aria-pressed', count === selectedCount ? 'true' : 'false');
        renderComparison(button, tier);
      });
      all('[data-tier-card]').forEach(card => {
        const count = Number(card.dataset.count);
        const tier = offerFor(count);
        card.hidden = !isPreorder && count !== 1;
        card.dataset.selected = count === selectedCount ? 'true' : 'false';
        card.dataset.available = tier && validId(tier.id) && tier.available === true ? 'true' : 'false';
        const price = card.querySelector('[data-tier-price]');
        const unit = card.querySelector('[data-tier-unit]');
        if (price && tier && typeof tier.priceText === 'string') price.textContent = tier.priceText;
        if (unit && tier && typeof tier.unitText === 'string') unit.textContent = tier.unitText;
        const comparison = card.querySelector('[data-tier-comparison]');
        const regularPrice = card.querySelector('[data-tier-regular-price]');
        const hasComparison = isPreorder && tier && validAmount(tier.price) && validPrice(tier.regularPrice) && tier.regularPrice > tier.price;
        if (comparison) comparison.hidden = !hasComparison;
        if (regularPrice) regularPrice.textContent = hasComparison ? formatPrice(tier.regularPrice) || '' : '';
        renderComparison(card, tier);
      });
      tierInputs.forEach(input => {
        const count = Number(input.value);
        const tier = offerFor(count);
        input.checked = count === selectedCount;
        input.disabled = submitting || uncertain || !browsableOffer(tier) || (!isPreorder && count !== 1);
      });
      all('[data-slot]').forEach(slot => { slot.hidden = Number(slot.dataset.slot) > selectedCount; });
      deckSelects.forEach(select => {
        const active = Number(select.dataset.slot) <= selectedCount;
        select.disabled = !active || submitting || uncertain;
        select.required = active;
      });
      all('[data-selected-comparison]').forEach(comparison => { renderComparison(comparison, offer); });
      if (offer) {
        setText('[data-price]', offer.priceText);
        setText('[data-unit-price]', offer.unitText);
      }
      setText('[data-selected-count]', selectedCount);
      const variantInput = one('[data-variant-id]');
      const planInput = one('[data-selling-plan]');
      if (variantInput) {
        variantInput.value = offer && validId(offer.id) ? String(offer.id) : '';
        variantInput.disabled = !ready();
      }
      if (planInput) {
        planInput.value = offer && validId(offer.sellingPlanId) ? String(offer.sellingPlanId) : '';
        planInput.disabled = !ready() || !offer || !validId(offer.sellingPlanId);
      }
      let label = texts.buy;
      if (submitting) label = texts.adding;
      setText('[data-submit-label]', label);
      all('[data-availability-note]').forEach(element => {
        element.hidden = ready();
        element.textContent = typeof texts.orderUnavailable === 'string' ? texts.orderUnavailable : '';
      });
      submitButtons.forEach(button => { button.disabled = !canPurchase; });
      form.setAttribute('aria-busy', submitting ? 'true' : 'false');
      recoveries.forEach(recovery => {
        recovery.hidden = !uncertain;
        if (cartUrl) recovery.href = cartUrl;
      });
      drawerRetries.forEach(button => {
        button.hidden = !drawerPending;
        button.disabled = drawerOpening || submitting;
      });
      showCountdown();
    };
    const refresh = () => {
      const changed = updatePhase();
      const dispatchChanged = beforeDispatch && Date.now() >= dispatchDate;
      if (dispatchChanged) beforeDispatch = false;
      const nextPricing = readPricing();
      const nextSignature = JSON.stringify(nextPricing);
      const pricingChanged = nextSignature !== pricingSignature;
      if (pricingChanged) {
        pricing = nextPricing;
        pricingSignature = nextSignature;
      }
      if (changed || dispatchChanged || pricingChanged) {
        render();
        if (changed && !submitting && !uncertain) announce(texts.changed);
      } else {
        showCountdown();
      }
      return changed;
    };
    const changeTier = event => {
      const input = event.target.closest('[data-tier]');
      if (!input || !root.contains(input) || submitting || uncertain) return;
      if (refresh()) return;
      const count = Number(input.value);
      if (![1, 2, 3].includes(count) || (phase !== 'preorder' && count !== 1)) return;
      const offer = offerFor(count);
      if (!browsableOffer(offer)) return;
      selectedCount = count;
      announce('');
      render();
    };
    const changeDeck = event => {
      const select = event.target.closest('[data-deck-select]');
      if (!select || !root.contains(select) || submitting || uncertain) return;
      synchronizeSlot(select);
      refresh();
      announce('');
      render();
    };
    const pickDeck = event => {
      const button = event.target.closest('[data-pick-deck]');
      if (!button || !root.contains(button) || submitting || uncertain) return;
      const value = button.value || button.dataset.pickDeck;
      const first = deckSelects.find(select => Number(select.dataset.slot) === 1);
      if (!first || !deckNames.includes(value)) return;
      first.value = value;
      first.dispatchEvent(new Event('change', { bubbles: true }));
      form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      first.focus({ preventScroll: true });
    };
    const pickTier = event => {
      const button = event.target.closest('[data-pick-tier]');
      if (!button || !root.contains(button) || submitting || uncertain) return;
      const count = Number(button.dataset.count || button.value || button.dataset.pickTier);
      const input = tierInputs.find(element => Number(element.value) === count);
      if (!input || input.disabled) return;
      changeTier({ target: input });
    };
    const gallery = one('[data-gallery]');
    if (gallery) {
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const countLabel = gallery.querySelector('[data-gallery-count]');
      let galleryIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));
      let pointerStart = null;
      const showSlide = index => {
        if (!slides.length) return;
        galleryIndex = (index + slides.length) % slides.length;
        const selected = slides[galleryIndex];
        slides.forEach((slide, position) => {
          slide.hidden = position !== galleryIndex;
          slide.setAttribute('aria-hidden', position === galleryIndex ? 'false' : 'true');
        });
        thumbs.forEach(thumb => {
          const active = thumb.dataset.galleryThumb === selected.dataset.gallerySlide;
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (countLabel) countLabel.textContent = `${galleryIndex + 1} / ${slides.length}`;
      };
      gallery.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb) {
          const index = slides.findIndex(slide => slide.dataset.gallerySlide === thumb.dataset.galleryThumb);
          if (index >= 0) showSlide(index);
        } else if (event.target.closest('[data-gallery-prev]')) showSlide(galleryIndex - 1);
        else if (event.target.closest('[data-gallery-next]')) showSlide(galleryIndex + 1);
      }, { signal: eventController.signal });
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.matches('input, textarea, select')) return;
        event.preventDefault();
        showSlide(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal: eventController.signal });
      gallery.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' || !event.target.closest('[data-gallery-slide]') || event.target.closest('a, button, input, select, textarea')) return;
        pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { signal: eventController.signal });
      gallery.addEventListener('pointerup', event => {
        if (!pointerStart || pointerStart.id !== event.pointerId) return;
        const dx = event.clientX - pointerStart.x;
        const dy = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) showSlide(galleryIndex + (dx < 0 ? 1 : -1));
      }, { signal: eventController.signal });
      gallery.addEventListener('pointercancel', () => { pointerStart = null; }, { signal: eventController.signal });
      showSlide(galleryIndex);
    }
    const peekDialog = one('[data-peek-dialog]');
    const peekConfigNode = one('script[data-peek-config]');
    let peekConfig;
    try {
      peekConfig = peekConfigNode ? JSON.parse(peekConfigNode.textContent) : null;
    } catch {
      peekConfig = null;
    }
    const peekDecks = peekConfig && Array.isArray(peekConfig.decks) ? peekConfig.decks.map(deck => ({
      key: deck.key,
      name: deck.name,
      cards: Array.isArray(deck.cards) ? deck.cards.filter(card => card && typeof card.src === 'string' && card.src.trim()).slice(0, 8) : []
    })).filter(deck => typeof deck.key === 'string' && typeof deck.name === 'string' && deck.cards.length) : [];
    const peekTexts = peekConfig && peekConfig.texts ? peekConfig.texts : {};
    const peekImage = one('[data-peek-image]');
    const peekThumbs = one('[data-peek-thumbs]');
    const peekTabs = all('[data-peek-tab]');
    let peekDeck = peekDecks[0];
    let peekIndex = 0;
    let peekOpener;
    const renderPeek = rebuild => {
      if (!peekDeck || !peekImage || !peekThumbs) return;
      const card = peekDeck.cards[peekIndex];
      peekImage.src = card.src;
      peekImage.alt = typeof card.alt === 'string' ? card.alt : peekDeck.name;
      peekImage.dataset.code = typeof card.code === 'string' ? card.code : '';
      setText('[data-peek-title]', peekDeck.name);
      const activeTab = peekTabs.find(button => button.value === peekDeck.key);
      const panel = one('[data-peek-panel]');
      if (panel && activeTab && activeTab.id) panel.setAttribute('aria-labelledby', activeTab.id);
      const counter = String(peekTexts.count || '[current] / [total]')
        .replace('[current]', String(peekIndex + 1))
        .replace('[total]', String(peekDeck.cards.length));
      setText('[data-peek-count]', counter);
      peekTabs.forEach(button => {
        const active = button.value === peekDeck.key;
        button.disabled = !peekDecks.some(deck => deck.key === button.value);
        button.dataset.active = String(active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      all('[data-peek-prev], [data-peek-next]').forEach(button => { button.disabled = peekDeck.cards.length < 2; });
      if (rebuild) {
        const fragment = document.createDocumentFragment();
        peekDeck.cards.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.peekThumb = String(index);
          button.setAttribute('aria-label', `${peekTexts.thumbnail || 'Preview card'} ${index + 1}: ${item.alt || item.code || peekDeck.name}`);
          const image = document.createElement('img');
          image.src = item.src;
          image.alt = '';
          image.width = 70;
          image.height = 120;
          image.loading = 'lazy';
          button.append(image);
          fragment.append(button);
        });
        peekThumbs.replaceChildren(fragment);
      }
      peekThumbs.querySelectorAll('[data-peek-thumb]').forEach(button => {
        const active = Number(button.dataset.peekThumb) === peekIndex;
        button.dataset.active = String(active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    const changePeekCard = direction => {
      if (!peekDeck) return;
      peekIndex = (peekIndex + direction + peekDeck.cards.length) % peekDeck.cards.length;
      renderPeek(false);
    };
    const openPeek = event => {
      const opener = event.target.closest('[data-peek-open]');
      if (!opener || !root.contains(opener) || !peekDialog || !peekImage || !peekThumbs || !peekDecks.length || typeof peekDialog.showModal !== 'function') return;
      let key = opener.value || opener.dataset.peekOpen;
      if (key === 'selected') {
        const first = deckSelects.find(select => Number(select.dataset.slot) === 1);
        const chosen = first && (peekDecks.find(deck => deck.name === first.value) || peekDecks[deckNames.indexOf(first.value)]);
        key = chosen ? chosen.key : peekDecks[0].key;
      }
      peekDeck = peekDecks.find(deck => deck.key === key) || peekDecks[0];
      peekIndex = 0;
      peekOpener = opener;
      renderPeek(true);
      if (!peekDialog.open) peekDialog.showModal();
    };
    if (peekDialog) {
      peekDialog.addEventListener('click', event => {
        const close = event.target.closest('[data-peek-close]');
        if (close) {
          peekDialog.close();
          return;
        }
        const tab = event.target.closest('[data-peek-tab]');
        if (tab) {
          const deck = peekDecks.find(item => item.key === tab.value);
          if (deck) {
            peekDeck = deck;
            peekIndex = 0;
            renderPeek(true);
          }
          return;
        }
        const thumb = event.target.closest('[data-peek-thumb]');
        if (thumb && peekDeck) {
          const index = Number(thumb.dataset.peekThumb);
          if (Number.isInteger(index) && index >= 0 && index < peekDeck.cards.length) {
            peekIndex = index;
            renderPeek(false);
          }
          return;
        }
        if (event.target.closest('[data-peek-prev]')) changePeekCard(-1);
        else if (event.target.closest('[data-peek-next]')) changePeekCard(1);
        else if (event.target === peekDialog) {
          const box = peekDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) peekDialog.close();
        }
      }, { signal: eventController.signal });
      peekDialog.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.matches('input, textarea, select')) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const tab = event.target.closest('[data-peek-tab]');
        if (tab && peekDeck) {
          const deckIndex = peekDecks.findIndex(deck => deck.key === peekDeck.key);
          peekDeck = peekDecks[(deckIndex + direction + peekDecks.length) % peekDecks.length];
          peekIndex = 0;
          renderPeek(true);
          const active = peekTabs.find(button => button.value === peekDeck.key);
          if (active) active.focus();
        } else {
          changePeekCard(direction);
        }
      }, { signal: eventController.signal });
      peekDialog.addEventListener('close', () => {
        if (!destroyed && peekOpener && peekOpener.isConnected) peekOpener.focus({ preventScroll: true });
      }, { signal: eventController.signal });
    }
    const hasKachingDrawer = () => typeof window.kachingCartApi?.openCart === 'function';
    const nativeDrawer = () => {
      const drawer = document.querySelector('cart-drawer');
      return drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function' ? drawer : null;
    };
    const drawerSections = drawer => [...new Set(drawer.getSectionsToRender().map(section => section.id))]
      .filter(id => typeof id === 'string' && /^[\w-]+$/.test(id)).slice(0, 5);
    const openCartDrawer = async (payload, trigger) => {
      if (destroyed) return false;
      if (hasKachingDrawer()) {
        document.dispatchEvent(new CustomEvent('kaching-cart:open', {
          bubbles: true,
          cancelable: true,
          detail: { refetchCart: true, element: trigger, cartOpenSource: 'add-to-cart' }
        }));
        return true;
      }
      const drawer = nativeDrawer();
      if (!drawer) return false;
      const sections = drawerSections(drawer);
      if (!sections.length) return false;
      const complete = state => sections.every(id => typeof state?.sections?.[id] === 'string' && state.sections[id].trim());
      if (!complete(payload)) {
        const url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.set('sections', sections.join(','));
        const response = await fetch(url.href, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: requestController.signal });
        if (!response.ok) return false;
        payload = { sections: await response.json() };
      }
      if (destroyed || !complete(payload)) return false;
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger);
      drawer.classList.remove('is-empty');
      drawer.renderContents(payload);
      return true;
    };
    const finishAdded = opened => {
      if (destroyed) return;
      submitting = false;
      drawerPending = !opened;
      updatePhase();
      render();
      announce(opened ? texts.added : texts.drawerError);
    };
    const retryDrawer = async event => {
      const button = event.target.closest('[data-open-cart]');
      if (!button || !root.contains(button) || !confirmedAdd || !drawerPending || drawerOpening || submitting || destroyed) return;
      event.preventDefault();
      drawerOpening = true;
      render();
      requestController = new AbortController();
      timeout = window.setTimeout(() => requestController.abort(), 20000);
      try {
        finishAdded(await openCartDrawer(null, button));
      } catch {
        if (!destroyed) finishAdded(false);
      } finally {
        drawerOpening = false;
        window.clearTimeout(timeout);
        if (!destroyed) render();
      }
    };
    const markUncertain = () => {
      uncertain = true;
      submitting = false;
      render();
      announce(texts.network);
      const recovery = recoveries.find(link => activePurchaseArea.contains(link));
      if (recovery) recovery.focus({ preventScroll: true });
    };
    const submit = async event => {
      event.preventDefault();
      if (destroyed || submitting || uncertain || drawerOpening) return;
      const origin = event.submitter || document.activeElement;
      if (origin && root.contains(origin)) activePurchaseArea = origin.closest('[data-purchase-area]') || form.closest('[data-purchase-area]') || form;
      if (refresh()) {
        announce(texts.changed);
        return;
      }
      if (!ready()) {
        render();
        announce(texts.unavailable);
        return;
      }
      for (let slot = 1; slot <= selectedCount; slot += 1) {
        const select = deckSelects.find(element => Number(element.dataset.slot) === slot);
        if (!select || !deckNames.includes(select.value)) {
          announce(texts.selection);
          const localSelect = localDeckSelect(slot);
          if (localSelect) localSelect.focus({ preventScroll: true });
          return;
        }
      }
      if (!form.checkValidity()) {
        announce(texts.selection);
        const invalidLocal = deckSelects.find(select => activePurchaseArea.contains(select) && !select.disabled && !select.checkValidity());
        if (invalidLocal) invalidLocal.focus({ preventScroll: true });
        return;
      }
      const offer = currentOffer();
      const chosenVariants = usesDeckVariants ? selectionsFor(selectedCount) : [];
      const properties = {
        'Order type': beforeDispatch || validId(offer.sellingPlanId) || chosenVariants.some(variant => validId(variant.sellingPlanId)) ? 'Preorder' : 'Standard',
        '_Campaign': config.campaignId
      };
      if (beforeDispatch) properties['Estimated dispatch'] = config.dispatchLabel;
      const items = [];
      const chosenItems = usesDeckVariants ? chosenVariants : [offer];
      chosenItems.forEach(variant => {
        const sellingPlan = validId(variant.sellingPlanId) ? variant.sellingPlanId : null;
        const existing = items.find(item => item.id === variant.id && (item.selling_plan || null) === sellingPlan);
        if (existing) existing.quantity += 1;
        else {
          const item = { id: variant.id, quantity: 1, properties: { ...properties } };
          if (sellingPlan) item.selling_plan = sellingPlan;
          items.push(item);
        }
      });
      confirmedAdd = false;
      drawerPending = false;
      submitting = true;
      announce('');
      render();
      requestController = new AbortController();
      timeout = window.setTimeout(() => requestController.abort(), 20000);
      try {
        const requestUrl = new URL(addUrl);
        const body = { items };
        if (hasKachingDrawer()) {
          // Let the confirmed response open Kaching once through its drawer event.
          requestUrl.searchParams.set('opens_cart', 'never');
        } else {
          const drawer = nativeDrawer();
          const sections = drawer && drawerSections(drawer);
          if (sections && sections.length) {
            body.sections = sections;
            body.sections_url = window.location.pathname;
          }
        }
        const response = await fetch(requestUrl.href, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          signal: requestController.signal
        });
        if (destroyed) return;
        if (response.ok) {
          confirmedAdd = true;
          let payload = null;
          try { payload = await response.json(); } catch {}
          finishAdded(await openCartDrawer(payload, origin));
          return;
        }
        if (response.status >= 500) {
          markUncertain();
          return;
        }
        let message = texts.error;
        try {
          const payload = await response.json();
          if (typeof payload.description === 'string') message = payload.description;
          else if (typeof payload.message === 'string') message = payload.message;
        } catch {}
        submitting = false;
        updatePhase();
        render();
        announce(message);
      } catch {
        if (!destroyed) {
          if (confirmedAdd) finishAdded(false);
          else markUncertain();
        }
      } finally {
        window.clearTimeout(timeout);
      }
    };

    form.addEventListener('submit', submit, { signal: eventController.signal });
    root.addEventListener('change', changeTier, { signal: eventController.signal });
    root.addEventListener('change', changeDeck, { signal: eventController.signal });
    root.addEventListener('click', pickDeck, { signal: eventController.signal });
    root.addEventListener('click', pickTier, { signal: eventController.signal });
    root.addEventListener('click', openPeek, { signal: eventController.signal });
    root.addEventListener('click', retryDrawer, { signal: eventController.signal });
    window.addEventListener('pageshow', event => {
      if (event.persisted && confirmedAdd && !uncertain) {
        confirmedAdd = false;
        submitting = false;
        refresh();
        render();
      } else {
        refresh();
      }
    }, { signal: eventController.signal });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); }, { signal: eventController.signal });
    if (sticky) {
      sticky.hidden = true;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          for (const entry of entries) sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        }, { threshold: 0 });
        observer.observe(root.querySelector('.tt-aff__hero') || form);
      }
    }
    const interval = window.setInterval(refresh, 1000);
    instances.set(root, () => {
      destroyed = true;
      eventController.abort();
      if (peekDialog && peekDialog.open) peekDialog.close();
      if (observer) observer.disconnect();
      if (requestController) requestController.abort();
      window.clearInterval(interval);
      window.clearTimeout(timeout);
      instances.delete(root);
    });
    [1, 2, 3].forEach(slot => {
      const primary = deckSelects.find(select => Number(select.dataset.slot) === slot);
      if (primary) synchronizeSlot(primary);
    });
    render();
  };
  const scan = scope => {
    if (scope.matches && scope.matches(selector)) initialize(scope);
    scope.querySelectorAll(selector).forEach(initialize);
  };
  window[controllerKey] = { scan };
  document.addEventListener('shopify:section:load', event => { scan(event.target); });
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) {
      if (root === event.target || event.target.contains(root)) dispose();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { scan(document); }, { once: true });
  else scan(document);
})();


  } catch(e) { console.error(e); }
})();
})();
